import {useNavigate} from "react-router-dom";
import SnackError from "../../components/SnackError";
import React from "react";
import {usePostPersonMutation} from "./people_api";
import PersonForm from "./PersonForm";
import {Card, CardContent} from "@mui/material";
import Title from "../navigation/Title";
import {TablesInsert} from "../../apitypes";


export const PersonCreate = () => {

    const [post, {
        isLoading: isUpdating,
        error,
        isError,
    }] = usePostPersonMutation();
    const navigate = useNavigate();
    const handleSubmit = async function (values: TablesInsert<"worker">) {
        const resp = await post(values)
        if ("data" in resp) {
            navigate("..")
        }
    };

    return <>
        <Title title={"Nova oseba"}/>
        <Card sx={{mt: "2em"}}>
            {isError && <SnackError error={error}/>}
            <CardContent>
                <PersonForm
                    isUpdating={isUpdating}
                    onSubmit={handleSubmit}
                    onCancel={() => navigate("..", {replace: true})}
                    object={{firstName: "", lastName: "", code: "", partnerCode:"",Active:true,documentID:""}}
                />
            </CardContent>
        </Card>
    </>;
}
